"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Trash = _interopRequireDefault(require("@honeybook/icons/dist/icons/Trash16"));
var _Download = _interopRequireDefault(require("@honeybook/icons/dist/icons/Download16"));
var _HBFileThumbnail = require("../HBFileThumbnail/HBFileThumbnail.styles");
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _withStopPropagation = _interopRequireDefault(require("../common/withStopPropagation"));
var _lodash = require("lodash");
var HBFileThumbnailActions = function HBFileThumbnailActions(_ref) {
  var onDeleteFile = _ref.onDeleteFile,
    onDownloadFile = _ref.onDownloadFile,
    isDeletable = _ref.isDeletable,
    file = _ref.file,
    deleteTooltipText = _ref.deleteTooltipText;
  return /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.ThumbnailActions, {
    hasDeleteButton: isDeletable
  }, /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "light-invisible",
    icon: _Download["default"],
    label: "download",
    onClick: (0, _withStopPropagation["default"])(function () {
      return onDownloadFile && onDownloadFile(file);
    }),
    size: "xs",
    testIdName: "download"
  }), isDeletable && (0, _lodash.isFunction)(onDeleteFile) && /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "light-invisible",
    icon: _Trash["default"],
    label: "delete",
    onClick: (0, _withStopPropagation["default"])(function () {
      return onDeleteFile(file);
    }),
    size: "xs",
    disabled: file.isDeleteDisabled,
    tooltip: deleteTooltipText,
    testIdName: "delete"
  }));
};
var _default = exports["default"] = HBFileThumbnailActions;
//# sourceMappingURL=HBFileThumbnailActions.js.map